import React, { useState } from 'react';
import '../../Styles/CreateEventsAnnounce.css';
import Loader from "../../Components/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';

function CreateEventsAnnounce() {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    time: '',
    type: 'event',
    audience: 'everyone',
    location: '',
    attachment: null,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 5 * 1024 * 1024) { // 5 MB limit
      toast.error("File size exceeds 5MB.");
      setFormData({ ...formData, attachment: null }); // Clear invalid file
    } else {
      setFormData({ ...formData, attachment: file });
    }
  };
  
  const convertTo12HourFormat = (time) => {
    const [hour, minute] = time.split(":");
    const isPM = hour >= 12;
    const twelveHour = isPM ? hour - 12 || 12 : parseInt(hour, 10);
    const amPm = isPM ? "PM" : "AM";
    return `${twelveHour}:${minute} ${amPm}`;
};


  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = localStorage.getItem("authToken");
    let formdata = new FormData();
    const formattedTime = convertTo12HourFormat(formData.time);
    // Append all fields
    formdata.append('title', formData.title);
    formdata.append('description', formData.description);
    formdata.append('date', formData.date);
    formdata.append('time', formattedTime);
    formdata.append('type', formData.type);
    formdata.append('audience', formData.audience);
    formdata.append('location', formData.location);
  
    // Append file if it exists
    if (formData.attachment) {
      formdata.append('attachment', formData.attachment);
    }
  
    try {
      const response = await axios.post(
        "https://api.uniums.com/api/announcement/create-announcement", 
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
  
      if (response.status === 201) {
        toast.success("Announcement details saved successfully");
        setFormData({
          title: '',
          description: '',
          date: '',
          time: '',
          type: 'event',
          audience: 'everyone',
          location: '',
          attachment: null,
        });
      }
    } catch (error) {
      console.error("Error saving announcement details:", error);
      toast.error("Failed to save announcement details");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="create-events-announce">
      <h1>Create Event or Announcement</h1>
      <form className="form_e" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="title">Title <span>*</span></label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="date">Date <span>*</span></label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="time">Time <span>*</span></label>
            <input
              type="time"
              id="time"
              name="time"
              value={formData.time}
              onChange={handleChange}
            
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="type">Type <span>*</span></label>
            <select
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="event">Event</option>
              <option value="announcement">Announcement</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="audience">Audience <span>*</span></label>
            <div className="radio-group radio-group-annoucement">
              <label>
                <input
                  type="radio"
                  name="audience"
                  value="everyone"
                  checked={formData.audience === 'everyone'}
                  onChange={handleChange}
                />
                Everyone
              </label>
              <label>
                <input
                  type="radio"
                  name="audience"
                  value="faculty"
                  checked={formData.audience === 'faculty'}
                  onChange={handleChange}
                />
                Faculty
              </label>
              <label>
                <input
                  type="radio"
                  name="audience"
                  value="students"
                  checked={formData.audience === 'students'}
                  onChange={handleChange}
                />
                Students
              </label>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="location">Location <span>*</span></label>
            <input
              type="text"
              id="location"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Enter location"
            />
          </div>
        </div>
        <div className="form-group form-group-e full-width">
          <label htmlFor="description">Description <span>*</span></label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Enter description"
            required
          ></textarea>
        </div>
        <div className="form-group full-width">
          <label htmlFor="attachment">Attachment</label>
          <input
            type="file"
            id="attachment"
            name="attachment"
            onChange={handleFileChange}
          />
        </div>
        <button type="submit" className="btn-submit-e">
          {loading ? <Loader /> : "Create"}
        </button>
      </form>
      <ToastContainer />
    </div>
  );
}

export default CreateEventsAnnounce;
